import { useContext } from 'react';
import { Navigate, Outlet } from 'react-router';
import { AuthContext }  from '../App';

function PrivateRoute(props) {
    const {isAuthenticated} = useContext(AuthContext);
    return isAuthenticated ? <Outlet /> : <Navigate to="/" />;
}

export default PrivateRoute;